import { render, staticRenderFns } from "./slices.vue?vue&type=template&id=0b86b56c&scoped=true&"
import script from "./slices.vue?vue&type=script&lang=js&"
export * from "./slices.vue?vue&type=script&lang=js&"
import style0 from "./slices.vue?vue&type=style&index=0&id=0b86b56c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b86b56c",
  null
  
)

export default component.exports